import { Link } from "react-router-dom";

export default function NotFoundPage() {
  return (
    <div
      className="min-h-screen bg-mfp-bg text-white flex items-center justify-center px-4"
      data-testid="not-found-page"
    >
      <div className="text-center">
        <div className="font-display text-7xl md:text-9xl">
          4<span className="text-mfp-gold">0</span>4
        </div>
        <p className="mt-4 text-mfp-muted uppercase tracking-widest text-sm">Seite nicht gefunden</p>
        <Link
          to="/"
          className="mfp-btn inline-block mt-8 bg-mfp-gold text-white px-6 py-3 hover:bg-mfp-goldHover transition-colors"
          data-testid="notfound-home"
        >
          Zurück zur Startseite
        </Link>
      </div>
    </div>
  );
}
